<template>
  <div class="column content-box">
    <woot-modal-header :header-title="pageTitle" />
    <form class="row" @submit.prevent="editLabel">
      <woot-input
        v-model.trim="title"
        :class="{ error: $v.title.$error }"
        class="medium-12 columns label-name--input"
        :label="$t(`${i18nPrefix}.FORM.NAME.LABEL`)"
        :placeholder="$t(`${i18nPrefix}.FORM.NAME.PLACEHOLDER`)"
        :error="getLabelTitleErrorMessage"
        @input="$v.title.$touch"
      />
      <woot-input
        v-model.trim="description"
        :class="{ error: $v.description.$error }"
        class="medium-12 columns"
        :label="$t(`${i18nPrefix}.FORM.DESCRIPTION.LABEL`)"
        :placeholder="$t(`${i18nPrefix}.FORM.DESCRIPTION.PLACEHOLDER`)"
        @input="$v.description.$touch"
      />

      <div class="medium-12">
        <label>
          {{ $t(`${i18nPrefix}.FORM.COLOR.LABEL`) }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="medium-12">
        <input v-model="showOnSidebar" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t(`${i18nPrefix}.FORM.SHOW_ON_SIDEBAR.LABEL`) }}
        </label>
      </div>
      <div class="modal-footer">
        <div class="medium-12 columns">
          <woot-button
            :is-disabled="$v.title.$invalid || uiFlags.isUpdating"
            :is-loading="uiFlags.isUpdating"
          >
            {{ $t(`${i18nPrefix}.FORM.EDIT`) }}
          </woot-button>
          <woot-button class="button clear" @click.prevent="onClose">
            {{ $t(`${i18nPrefix}.FORM.CANCEL`) }}
          </woot-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import validationMixin from './validationMixin';
import validations from './validations';
import { DEFAULT_LABEL_TYPE, findLabelType } from './labelTypes';

export default {
  mixins: [alertMixin, validationMixin],
  props: {
    type: {
      type: String,
      default: DEFAULT_LABEL_TYPE,
    },
    selectedResponse: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      description: '',
      showOnSidebar: true,
      color: '',
    };
  },
  validations,
  computed: {
    labelType() {
      return findLabelType(this.type);
    },
    i18nPrefix() {
      return this.labelType.i18nPrefix;
    },
    uiFlags() {
      return this.$store.getters[`${this.labelType.storeModule}/getUIFlags`];
    },
    pageTitle() {
      return `${this.$t(`${this.i18nPrefix}.EDIT.TITLE`)} - ${
        this.selectedResponse.title
      }`;
    },
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    setFormValues() {
      this.title = this.selectedResponse.title;
      this.description = this.selectedResponse.description;
      this.showOnSidebar = this.selectedResponse.show_on_sidebar;
      this.color = this.selectedResponse.color;
    },
    editLabel() {
      this.$store
        .dispatch(`${this.labelType.storeModule}/update`, {
          id: this.selectedResponse.id,
          color: this.color,
          description: this.description,
          title: this.title.toLowerCase(),
          show_on_sidebar: this.showOnSidebar,
        })
        .then(() => {
          this.showAlert(
            this.$t(`${this.i18nPrefix}.EDIT.API.SUCCESS_MESSAGE`)
          );
          setTimeout(() => this.onClose(), 10);
        })
        .catch(() => {
          this.showAlert(this.$t(`${this.i18nPrefix}.EDIT.API.ERROR_MESSAGE`));
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// Label API supports only lowercase letters
.label-name--input {
  ::v-deep {
    input {
      text-transform: lowercase;
    }
  }
}
</style>
